import labels from '../../contexts/CruiseSearchContext/labels.json';

export const TEST_DATA = {
  labels,
};

export const TYPES_SIGNIN = ['EMAIL', 'LOYALTY'];
